import React from 'react';
import cn from 'classnames';

import styles from './Box.module.scss';

export interface BoxProps {
    children: React.ReactNode;
    className?: string;
}

const Box: React.FC<BoxProps> = (props) => {
    return <div className={cn(styles.box, [props.className])}>
        {props.children}
    </div>;
};

export default Box;